import { getAsset } from "../../services/assetStore";

export const fetchLyrics = async (lyricsUrl, onFetchProgress) => {
  try {
    const response = await getAsset(lyricsUrl, false, onFetchProgress);
    const jsonResponse = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response)))
    return jsonResponse;
  } catch (e) {
    throw new Error("Issue fetching lyrics");
  }
}


/*

  const headers = new Headers({
    "x-auth-token": AUTH_TOKEN
  });


  console.log("pgw downloadToArrayBuffer Request Headers (fetch will use):");
  headers.forEach((value, key) => console.log(`${key}: ${value}`));

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
      mode: "cors" // This triggers the OPTIONS preflight automatically
    });

    console.log("pgw downloadToArrayBufferResponse Headers:");
    for (let [key, value] of response.headers.entries()) {
      console.log(`${key}: ${value}`);
    }

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    const arrayBuffer = await response.arrayBuffer();
    console.log(`pgw downloadToArrayBuffer Downloaded ${arrayBuffer.byteLength} bytes`);
    return arrayBuffer;

  } catch (err) {
    console.error("pgw downloadToArrayBuffer Failed to download audio:", err);
	throw new Error(`HTTP error: ${err}`);
  }



*/
